// import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
// import { Router } from '@angular/router';
// import { MatDialog } from '@angular/material/dialog';
// import { LoggerService } from 'src/shared/logger/logger.service';
// import { Levels } from 'src/shared/logger/levels.enum';
// import { SearchModuleService } from 'src/shared/search.module.service';
// import { ReportIssueDialogComponent } from 'src/shared/Dialogs/report-issue/dialog.reportIssue.component';
// import { AccessAuthService } from 'src/shared/access.auth.service';
// import jwt_decode from 'jwt-decode'
// import { ResetPasswordDialogComponent } from 'src/shared/Dialogs/reset-password/dialog.resetPassword.component';
// import { AdminService } from 'src/admin/services/admin.service';

// @Component({
//   selector: 'app-navbar',
//   templateUrl: './navbar.component.html',
//   styleUrls: ['./navbar.component.css']
// })
// export class NavbarComponent implements OnInit, OnChanges {
//   isCollapsed = true;
//   showFiller = false;
//   user_info_obj: any;
//   adminAuthorization: boolean = false;

//   constructor(public router: Router,
//     private loggerService: LoggerService,
//     private searchModuleService: SearchModuleService,
//     public dialog: MatDialog,
//     public accessAuthService: AccessAuthService,
//     public adminService: AdminService,) {

//   }
//   ngOnChanges(changes: SimpleChanges): void {
//     // if (!this.user_info_obj) {
//     //   if (localStorage.getItem('accessToken')) {
//     //     this.user_info_obj = jwt_decode(localStorage.getItem('accessToken'));
//     //   } else {
//     //     this.user_info_obj = null;
//     //   }
//     // }
//   }

//   ngOnInit(): void {
//     // if (localStorage.getItem('accessToken')) {
//     //   this.user_info_obj = jwt_decode(localStorage.getItem('accessToken'));
//     // } else {
//     //   this.user_info_obj = null;
//     // }
//     this.accessAuthService.user_info_obj_BehaviorSubject.subscribe(data => this.user_info_obj = data)
//     this.accessAuthService.isAdmin.subscribe(data => this.adminAuthorization = data)
//   }

//   logOut(): void {
//     if (localStorage.getItem('accessToken')) {
//       localStorage.removeItem('accessToken');
//       this.accessAuthService.isAdmin.next(false);
//       this.accessAuthService.user_info_obj_BehaviorSubject.next(null)
//     }
//     this.router.navigate(['/login']);
//     this.loggerService.log("NavbarComponent", `logged out`, Levels.info)
//   }

//   openDialog(): void {
//     this.searchModuleService.openSearchDialog();
//   }

//   goToHome() {
//     this.router.navigate(['/home'])
//   }

//   openConfirmationDialog(): void {
//     const dialogRef = this.dialog.open(ReportIssueDialogComponent, {
//       minWidth: '50vw',
//       maxWidth: '50vw',
//       minHeight: '50%',
//       data: {},
//       disableClose: true
//     });

//     dialogRef.afterClosed().subscribe(result => {
//       if (result) {
//         // this.adminService.updatedUserID.next(userToBeUpdated.id);
//         // this.router.navigate(['resetPassword'], { relativeTo: this.activatedRoute })
//       }
//     });

//   }

//   openResetPasswordDialog() {
//     const dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
//       minWidth: '50vw',
//       maxWidth: '50vw',
//       minHeight: '50%',
//       data: {},
//       disableClose: true
//     });

//     dialogRef.afterClosed().subscribe(result => {
//       if (result) {
//       }
//     });
//   }


// }




//this is the old code

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { SearchModuleService } from 'src/shared/search.module.service';
import { ReportIssueDialogComponent } from 'src/shared/Dialogs/report-issue/dialog.reportIssue.component';
import { AccessAuthService } from 'src/shared/access.auth.service';
import jwt_decode from 'jwt-decode'
import { ResetPasswordDialogComponent } from 'src/shared/Dialogs/reset-password/dialog.resetPassword.component';
import { AdminService } from 'src/admin/services/admin.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
  providers: [AccessAuthService]
})
export class NavbarComponent implements OnInit {
  isCollapsed = true;
  showFiller = false;
  user_info_obj: any;
  adminAuthorization: boolean = false;

  constructor(public router: Router,
    private loggerService: LoggerService,
    private searchModuleService: SearchModuleService,
    public dialog: MatDialog,
    public accessAuthService: AccessAuthService,
    public adminService: AdminService,) {

  }

  ngOnInit(): void {
    this.user_info_obj = jwt_decode(localStorage.getItem('accessToken'));
    // console.log(this.user_info_obj);
    this.accessAuthService.isAdmin.subscribe(data => this.adminAuthorization = data)
  }

  logOut(): void {
    if (localStorage.getItem('accessToken')) {
      localStorage.removeItem('accessToken');
      this.accessAuthService.isAdmin.next(false);
    }
    this.router.navigate(['/login']);
    this.loggerService.log("NavbarComponent", `logged out`, Levels.info)
  }

  openDialog(): void {
    this.searchModuleService.openSearchDialog();
  }

  goToHome() {
    this.router.navigate(['/home'])
  }

  openConfirmationDialog(): void {
    const dialogRef = this.dialog.open(ReportIssueDialogComponent, {
      minWidth: '50vw',
      maxWidth: '50vw',
      minHeight: '50%',
      data: {},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.adminService.updatedUserID.next(userToBeUpdated.id);
        // this.router.navigate(['resetPassword'], { relativeTo: this.activatedRoute })
      }
    });

  }

  openResetPasswordDialog() {
    const dialogRef = this.dialog.open(ResetPasswordDialogComponent, {
      minWidth: '50vw',
      maxWidth: '50vw',
      minHeight: '50%',
      data: {},
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
      }
    });
  }


}
